var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CCol',{ref:"content",attrs:{"xs":"12","lg":"12"}},[_c('CCard',[_c('CCardBody',[_c('v-card',{staticStyle:{"padding-top":"20px","padding-left":"20px","padding-right":"20px","padding-bottom":"30px"},attrs:{"shaped":""}},[_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"600px"},attrs:{"center":_vm.center,"zoom":5,"map-type-id":"hybrid","options":{
              zoomControl: true,
              mapTypeControl: true,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false,
            }}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":m.position,"title":m.title,"clickable":true,"draggable":false,"icon":{
                url: require('../assets/icons/ico_marker.png'),
                scaledSize: { width: 60, height: 50 },
              }},on:{"click":function($event){return _vm.profilePath(m.position, m.id)}}})}),1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }